import React, { useState, useEffect, useRef } from "react";
import { Col, FormGroup, Input, Label, Button, Row, InputGroup, InputGroupText, CardBody, Card } from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import Addicon from "assets/icon/EditConfig.svg"; 
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import ClientLevelConfigurationTabs from "../ClientLevelConfigurationTabs";
import Calendar from "assets/icon/calendar-icon.svg";
import useAxios from 'hooks/useAxios';
import { dateFormate } from 'utils/columns';
import { toast } from "react-toastify";
import Arrow from 'assets/icon/LeftChevron.svg'
import { json } from "d3";
let hasDatePopupOpen = false;
const initialValues = {
  coveredEntity: "",
  pharmacy: "",
  tpa: "",
};
const ClaimRule = ({ appFilter, onHandleReset,
  setRowConfig, setConfigRules,searchTerms , search , refetch , 
  SelectedRow,
  setSelectedRow,
  selectedRowDynamic,
  //editConfigtoggle,
  // setEditConfigToggle,
  setClientCongigToggle, }) => {
  const API = useAxios();
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState(data);
  const [isdiable, setdiable] = useState(true);
  const [appdisable, setAppdisable] = useState(true);
  //const [lookBackPeriod, setlookBackPeriod] = useState(data.lookBackPeriod);
  const [contractLive, setContractLive] = useState(false);
  const [state, updateState] = useState({
    initialValues: {
      checkLookBackPeriod: true,
      C2D: false,
      C3D: false,
      C4D: false,
      C5D: false,
      cashCardStatus: false,
      cashCardWindow: "",
      checkLookBackPeriod: true,
      contractLiveDate: true,
      DISP: 0,
      DCL: false,
      DEC: false,
      duplicateRxCheck: true,
      LBP: 0,
      OSD: "",
      otc: false,
      pharmacyStatus: true,
      profitRule: false,
      profitThreshold: "$ 0.00",
      reprocessing: false,
      reprocessingWindow: "",
      SIC: false,
      VDC: false,
      OGT: "",
      OGAT: "",
      OTC: false
    }
  });
  const formikRef = useRef();

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const { initialValues } = state;
  useEffect(() => {
    // setTableData[{...initialvalues}];
    fetchOrderContractsConfig();
  }, []);

  const fetchOrderContractsConfig = async () => {
    try {
      const { data } = await API.get(`GWConfig/Configuration/OrderContractConfig/${SelectedRow.thirdPartyAdminID}/${SelectedRow.ceid}/${SelectedRow.phid}`, {
        hasDefaultURL: true,
      });
      if (data) {
        setData(data);
        setTotalItem(data.totalRecords);
      } else {
        setData([]);
        setTotalItem(0);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (data !== undefined && data.length > 0) {
      setdiable(false);
      let temp = state;
      for (var x in data) {
        var code = data[x].code;
        if (code === "OSD" || code === "DISP") {
          temp.initialValues[code] = data[x].defaultConfigValue;
        }
        else if (code === "LBP") {
          temp.initialValues[code] = parseInt(data[x].defaultConfigValue);
        }
        else if (code == "OGT") {
          var val = data[x].defaultConfigValue == "S" ? 2 : 1;
          temp.initialValues[code] = val;
        }
        else if (code == "OGAT") {
          var val = data[x].defaultConfigValue == "M" ? 2 : 1;
          temp.initialValues[code] = val;
        }
        else {
          var val = data[x].defaultConfigValue == "Y" ? true : false;
          temp.initialValues[code] = val;
        }
      }
      setState(temp);
    }
    else
      setdiable(true);
    setTableData(data);


    //   setState({
    //     initialValues: {
    //       checkLookBackPeriod:data.checkLookBackPeriod,
    //       c2DrugCheck:data.c2DrugCheck,
    //       c3DrugCheck:data.c3DrugCheck,
    //       c4DrugCheck:data.c4DrugCheck,
    //       c5DrugCheck:data.c5DrugCheck,
    //       cashCardStatus:data.cashCardStatus,
    //       cashCardWindow:data.cashCardWindow,
    //       checkLookBackPeriod:data.checkLookBackPeriod,
    //       contractLiveDate:data.contractLiveDate,
    //       dispensingfeeCheck:data.dispensingfeeCheck,
    //       drugClassCheck:data.drugClassCheck,
    //       drugExclusionCheck:data.drugExclusionCheck,
    //       duplicateRxCheck:data.duplicateRxCheck,
    //       lookBackPeriod:data.lookBackPeriod,
    //       orderingStartDate:data.orderingStartDate,
    //       otc:data.otc,
    //       pharmacyStatus:data.pharmacyStatus,
    //       profitRule:data.profitRule,
    //       profitThreshold:"$ 0.00",
    //       reprocessing:data.reprocessing,
    //       reprocessingWindow:"",
    //       supplyCheck:data.supplyCheck,
    //       vaccineCheck:data.vaccineCheck,
    //       orderGenerationType:data.orderGenerationType
    //     }
    // });
  }, [data]);

  const lookBackPeriodOpt = [
    { lookBackPeriod: 30, label: "30 Days" },
    { lookBackPeriod: 60, label: "60 Days" },
    { lookBackPeriod: 90, label: "90 Days" },
    { lookBackPeriod: 120, label: "120 Days" },
  ];

  const reportOpt = [
    { id: 30, label: "30 Days" },
    { id: 60, label: "60 Days" },
    { id: 90, label: "90 Days" },
    { id: 120, label: "120 Days" },
  ];

  const orderGenerationOpt = [
    { id: 1, label: "Auto Generate/Replenishment" },
    { id: 2, label: "PO Split" },
  ];


  const autoGeneratedPOApprovalOPt = [
    { id: 1, label: "Always Auto Approve" },
    { id: 2, label: "Never Approve" },
  ];
  const validationSchema = Yup.object({
    coveredEntity: Yup.string().required("Required"),
  });


  const handleSaveConfig = async () => {
    let frk = formikRef.current.values;
    var param = {};

    var arrData = [];

    var arr = {};
    arr.code = "SIC";
    arr.description = "";
    arr.defaultConfigValue = frk["SIC"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "VDC";
    arr.description = "";
    arr.defaultConfigValue = frk["VDC"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "LBP";
    arr.description = "";
    arr.defaultConfigValue = frk["LBP"];
    arrData.push(arr);

    arr = {};
    arr.code = "C2D";
    arr.description = "";
    arr.defaultConfigValue = frk["C2D"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "C3D";
    arr.description = "";
    arr.defaultConfigValue = frk["C3D"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "C4D";
    arr.description = "";
    arr.defaultConfigValue = frk["C4D"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "C5D";
    arr.description = "";
    arr.defaultConfigValue = frk["C5D"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "DCL";
    arr.description = "";
    arr.defaultConfigValue = frk["DCL"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "DEC";
    arr.description = "";
    arr.defaultConfigValue = frk["DEC"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "OTC";
    arr.description = "";
    arr.defaultConfigValue = frk["OTC"] == true ? "Y" : "N";
    arrData.push(arr);

    arr = {};
    arr.code = "DISP";
    arr.description = "";
    arr.defaultConfigValue = 0;
    arrData.push(arr);

    arr = {};
    arr.code = "OSD";
    arr.description = "";
    arr.defaultConfigValue = frk["OSD"];
    arrData.push(arr);

    arr = {};
    arr.code = "OGT";
    arr.description = "";
    arr.defaultConfigValue = frk["OGT"] == "1" ? "A" : "S";
    arrData.push(arr);

    arr = {};
    arr.code = "OGAT";
    arr.description = "";
    arr.defaultConfigValue = frk["OGAT"] == "1" ? "A" : "M";
    arrData.push(arr);

    // arr = {};
    // arr.code = "DCL";
    // arr.description = "";
    // arr.defaultConfigValue = "Y";
    // arrData.push(arr);

    param.JsonStr = arrData;

    try {
      const { data } = await API.post(`GWConfig/Contracts/SaveContractConfig/${appFilter.thirdPartyAdminID}/${appFilter.coveredEntityID}/${appFilter.pharmacyID}`, param, {
        hasDefaultURL: true,
      });
      if (data) {
        toast.success("Configurations saved successfully.");
        onHandleReset();
        handleReset();
      } else {
        toast.error("An error occurred");
        //setData([]);
        //setTotalItem(0);
      }
    } catch (error) { }
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const handleReset = () => {
    setState({
      initialValues: {
        checkLookBackPeriod: true,
        C2D: false,
        C3D: false,
        C4D: false,
        C5D: false,
        cashCardStatus: false,
        cashCardWindow: "",
        checkLookBackPeriod: true,
        contractLiveDate: true,
        DISP: 0,
        DCL: false,
        DEC: false,
        duplicateRxCheck: true,
        LBP: 0,
        OSD: "",
        otc: false,
        pharmacyStatus: true,
        profitRule: false,
        profitThreshold: "$ 0.00",
        reprocessing: false,
        reprocessingWindow: "",
        SIC: false,
        VDC: false,
        OGT: "",
        OGAT: ""
      }
    });
  }

  const handleChange = event => {
    setMessage(event.target.value);
  };

  const handleSwitchChange = (e, val) => {
    let frk = formikRef.current.values;
    if (val == "LBP" || val == "OGT" || val == "OGAT") {
      frk[val] = e.target.value;
    }
    else if (val == "OSD") {
      frk[val] = dateFormate(e);
    }
    else {
      frk[val] = e.target.checked;
    }
    setState({
      initialValues: frk
    });
  }

  // const handelClickimage = () => {
  //   //setEditConfigToggle(false);
  //   setRowConfig(true);
  //   setClientCongigToggle(false);
  //   setConfigRules(false)
  // };


  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      innerRef={formikRef}
      children={(props) => {
        // const { isSubmitting, handleSubmit } = props;
        return (
          <div>
            <Card className="border-0 shadow-top my-3">
              <CardBody className="section-devider-border">
                <h4
                  className="f-18 text-primary font-weight-700"
                  style={{ cursor: "pointer" }}
                  // onClick={handelClickimage}
                >
                  <span
                    style={{
                      paddingRight: "5px",
                      alignItems: "center",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    {/* <img style={{ width: "8px", alignItems: "center" }} src={Arrow} /> */}
                  </span>{" "}
                  Contract Configuration
                </h4>

                <ErrorBoundary>
                  <ClientLevelConfigurationTabs
                    data={data}
                    selectedRowDynamic = {selectedRowDynamic}
                    search={search}
                    searchTerms={searchTerms}
                    refetch = {refetch}
                    // ce={searchTerms.coveredEntityID}
                    // contractIds={rowData.contractId}
                    // tenantID={tenantID}
                    rowData={SelectedRow}
                  />
                </ErrorBoundary>

                {/* <div className="claim-rule section-devider-border card-body">
            <h5 className="f-15 text-primary font-weight-700 mb-3">
              Claims Rules Check On App Level
            </h5>
            <Row>
              <Col md="3">
                <FormGroup switch>
                  <Input
                    type="switch"
                    id="contractLiveDate"
                    name="contractLiveDate"
                    checked={initialValues.contractLiveDate}
                    disabled={appdisable}
                    onChange={(e) => handleSwitchChange(e, 'contractLiveDate')}
                  />
                  <Label check className="toggle-label" >
                    DOS within Contract Live Date
                  </Label>
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup switch >
                  <Input
                    id="duplicateRxCheck"
                    name="duplicateRxCheck"
                    type="switch"
                    checked={initialValues.duplicateRxCheck}
                    disabled={appdisable}
                    onChange={(e) => handleSwitchChange(e, 'duplicateRxCheck')}
                  />
                  <Label check className="toggle-label" for='toggle-label2'>
                    Duplicate Rx check
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup switch>
                  <Input
                    type="switch"
                    id='checkLookBackPeriod'
                    name="checkLookBackPeriod"
                    checked={initialValues.checkLookBackPeriod}
                    disabled={appdisable}
                    onChange={(e) => handleSwitchChange(e, 'checkLookBackPeriod')}
                  />
                  <Label check className="toggle-label" for='checkLookBackPeriod'>
                    DOS within Look Back Period
                  </Label>
                </FormGroup>
              </Col>
              <Col md="7">
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Field
                        id="LBP"
                        name="LBP"
                        type="text"
                        autoComplete="off"
                        component={FormikSelectField}
                        defaultoption="--Select--"
                        value={initialValues.LBP || ""}
                        disabled={isdiable}
                        options={lookBackPeriodOpt}
                        keys={{
                          id: "lookBackPeriod",
                          label: "label",
                        }}
                        onChange={(e) => handleSwitchChange(e, 'LBP')}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <Label className="mt-2">
                      Look Back Period
                    </Label>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            <h5 className="f-15 text-primary font-weight-700 mb-3">
              Claims Rules On GW Chain Level
            </h5>
            <Row>
              <Col md="3">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="VDC"
                    name="VDC"
                    checked={initialValues.VDC}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'VDC')}
                  />
                  <Label check className="toggle-label">
                    Vaccines Blocks
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="C2D"
                    name="C2D"
                    checked={initialValues.C2D}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'C2D')}
                  />
                  <Label check className="toggle-label">
                    C2 Blocks
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="C3D"
                    name="C3D"
                    checked={initialValues.C3D}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'C3D')}
                  />
                  <Label check className="toggle-label">
                    C3 Blocks
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="C4D"
                    name="C4D"
                    checked={initialValues.C4D}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'C4D')}
                  />
                  <Label check className="toggle-label">
                    C4 Blocks
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="C5D"
                    name="C5D"
                    checked={initialValues.C5D}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'C5D')}
                  />
                  <Label check className="toggle-label">
                    C5 Blocks
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="SIC"
                    name="SIC"
                    checked={initialValues.SIC}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'SIC')}
                  />
                  <Label check className="toggle-label">
                    Supplies Indicator N Blocks
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="DCL"
                    name="DCL"
                    checked={initialValues.DCL}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'DCL')}
                  />
                  <Label check className="toggle-label">
                    OTC Blocks
                  </Label>
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="DEC"
                    name="DEC"
                    checked={initialValues.DEC}
                    disabled={isdiable}
                    onChange={(e) => handleSwitchChange(e, 'DEC')}
                  />
                  <Label check className="toggle-label">
                    Drug Exclusion Blocks
                  </Label>
                </FormGroup>
              </Col>

            </Row>
            {/* <Row>
            <Col md="2">
                <FormGroup switch >
                  <Input
                    disabled={appdisable}
                    type="switch"
                    id="profitRule"
                    name="profitRule" 
                    checked={data.profitRule}
                  />
                  <Label check className="toggle-label">
                    Profit Rule
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <Field
                    id="profitThreshold"
                    name="profitThreshold"
                    type="text"
                    autoComplete="off"
                    component={FormikInputField}
                    defaultValue={data.profitThreshold}
                    disabled={appdisable}
                  />          
                </FormGroup> 
              </Col>
              <Col md="2">
              <Label for="threshold" className="float-start mt-2 ">Profit Threshold</Label>   
              </Col>
            </Row> */}
                {/* <Row>
              <Col md="2">
                <FormGroup switch >
                  <Input
                    type="switch"
                    id="cashCardStatus"
                    name="cashCardStatus" 
                    checked={data.cashCardStatus}
                    disabled={appdisable}
                  />
                  <Label check className="toggle-label">
                    Cash Card Status
                  </Label>
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup >
                  <Field
                    id="cashCardWindow"
                    name="cashCardWindow"
                    type="text"
                    autoComplete="off"
                    component={FormikSelectField}
                    defaultoption="--Select--"
                    defaultValue={data.cashCardWindow}
                    disabled={appdisable}
                    options={reportOpt}
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="2">
                <Label className="float-start mt-2 ">
                  CashCard True-Up Window
                </Label>
              </Col>
              <Col md="2">
                    <FormGroup switch>
                      <Input
                        type="switch"
                        id="reprocessing"
                        name="reprocessing" 
                        checked={data.reprocessing}
                        disabled={appdisable}
                      />
                      <Label check className="toggle-label">
                        Reprocessing
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                <FormGroup >
                  <Field
                    id="reprocessingWindow"
                    name="reprocessingWindow"
                    type="text"
                    autoComplete="off"
                    component={FormikSelectField}
                    defaultoption="--Select--"
                    defaultValue={data.reprocessingWindow}
                    disabled={appdisable}
                    options={reportOpt}
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="2">
                <Label className="float-start mt-2 ">
                  Reprocessing Window
                </Label>
                </Col>

            </Row> */}
                {/* <hr />

            <h5 className="f-15 text-primary font-weight-700 mb-3">
              Claims Rule Check On Contract Level
            </h5>
            <Row>
              <Col md="5" >
                <FormGroup switch>
                  <Input
                    type="switch"
                    id="pharmacyStatus"
                    name="pharmacyStatus"
                    checked={data.pharmacyStatus}
                    disabled={appdisable}
                  />
                  <Label check className="toggle-label">
                    Pharmacy Status
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <hr />
            <h5 className="f-15 text-primary font-weight-700 mb-3">
              Ordering Configurations
            </h5>
            <Row>
              <Col md="2">
                <Label className="float-end mt-2">Ordering Start Date</Label>
              </Col>
              <Col md="2">
                <FormGroup>
                  <InputGroup>
                    <Field
                      type="text"
                      id="OSD"
                      name="OSD"
                      autoComplete="off"
                      placeholder="--Select--"
                      component={FormikDatePicker}
                      value={initialValues.OSD || ""}
                      disabled={isdiable}
                      onChange={(e) => handleSwitchChange(e, 'OSD')}
                    />
                    <InputGroupText
                      onClick={() => handleDateClick("OSD")}
                    >
                      <img src={Calendar} alt="" />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md="2">
                <Label className="float-end mt-2" for="orderGenerationType">Order Generation Type</Label>
              </Col>

              <Col md="2" >
                <FormGroup>

                  <Field
                    id="OGT"
                    name="OGT"
                    type="text"
                    autoComplete="off"
                    component={FormikSelectField}
                    disabled={isdiable}
                    defaultoption="--Select--"
                    value={initialValues.OGT || ""}
                    options={orderGenerationOpt}
                    onChange={(e) => handleSwitchChange(e, 'OGT')}
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>

              </Col>

            </Row>
            <Row>

              <Col md="2">
                <Label className="float-end mt-2" for="autoGeneratedPOApproval">Auto Generated PO Approval</Label>
              </Col>

              <Col md="2" >
                <FormGroup>

                  <Field
                    id="OGAT"
                    name="OGAT"
                    type="text"
                    autoComplete="off"
                    component={FormikSelectField}
                    disabled={isdiable}
                    defaultoption="--Select--"
                    value={initialValues.OGAT || ""}
                    options={autoGeneratedPOApprovalOPt}
                    onChange={(e) => handleSwitchChange(e, 'OGAT')}
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>

              </Col>
            </Row>

            <Row>
              <Col md={10}></Col>
              <Col md={2}>
                <Button disabled={isdiable} onClick={handleSaveConfig} color="primary" size="sm" className="px-4">
                  Save Config
                </Button>
              </Col>
            </Row> */}


                {/* </div> */}
              </CardBody>
            </Card>
          </div>
        );
      }}
    ></Formik>
  );
};

export default ClaimRule;
